import { useState } from 'react'
import { Box, Divider, Drawer, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import HistoryIcon from '@mui/icons-material/History'
import { com } from '@eidu/web'
import VersionHistory from './VersionHistory'
import EntityId = com.eidu.sharedlib.entity.EntityId

type VersionHistoryDrawerProps = {
  entityId: EntityId
  initialOpen?: boolean
  initialCompareVersionId?: string
}

const DRAWER_WIDTH = 420

const VersionHistoryDrawer = ({
  entityId,
  initialOpen = false,
  initialCompareVersionId,
}: VersionHistoryDrawerProps) => {
  const [open, setOpen] = useState(initialOpen || !!initialCompareVersionId)

  return (
    <>
      <Tooltip title="Version history">
        <IconButton onClick={() => setOpen(true)} aria-label="Open version history" data-testid="version-history-open">
          <HistoryIcon />
        </IconButton>
      </Tooltip>
      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
        PaperProps={{ sx: { width: DRAWER_WIDTH, maxWidth: '100vw' } }}
      >
        <Stack sx={{ height: '100%' }}>
          <Stack
            direction="row"
            sx={{
              alignItems: 'center',
              justifyContent: 'space-between',
              px: 2,
              py: 1.5,
              flexShrink: 0,
            }}
          >
            <Stack>
              <Typography variant="overline" color="text.secondary" sx={{ lineHeight: 1 }}>
                Published
              </Typography>
              <Typography variant="h6">Version history</Typography>
            </Stack>
            <IconButton onClick={() => setOpen(false)} aria-label="Close version history" size="small">
              <CloseIcon />
            </IconButton>
          </Stack>
          <Divider />
          <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', px: 2, display: 'flex', flexDirection: 'column' }}>
            <VersionHistory entityId={entityId} initialCompareVersionId={initialCompareVersionId} />
          </Box>
        </Stack>
      </Drawer>
    </>
  )
}

export default VersionHistoryDrawer
